module.exports = __webpack_public_path__ + "img/choose.83e082bc.svg";